let React    = require('react');
let ReactDom = require('react-dom');
let Utils    = require('utils');

import S3Upload from 's3_upload';
// -------------------------------------------------------

class Welcome extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      event     : {},
      name      : '',
      thumbnail : '',
      loading   : false,
      error     : '',
    };
  }
  // -------------------------------------------------------

  /*
   * イベント設定
   */
  setEvent(column, ev) {
    let event = this.state.event;
    event[column] = ev;
    this.setState({ event: event });
  }
  // -------------------------------------------------------

  /*
   * アップロード進捗反映
   */
  actionProgress() {
    let media = this.state.event.get_media.bind(this)();
    let last_media = media[(media.length - 1)];
    if( last_media != undefined && last_media.progress == 100 ){
      this.setState({ thumbnail: last_media.url });
    }
  }
  // -------------------------------------------------------

  /*
   * 登録
   */
  submit(e) {
    if( e != undefined ) e.preventDefault();
    const { name, thumbnail, loading } = this.state;
    if( !name || loading ) return;

    this.setState({ loading: true, error: '' });
    Utils.request('/api/welcome/submit', { name, thumbnail },
      () => { Utils.redirect('/'); },
      (res) => { this.setState({ loading: false, error: (res.body && res.body.message) || 'エラーが発生しました' }); },
      true, false
    );
  }
  // -------------------------------------------------------

  render() {
    const { name, thumbnail, loading, error } = this.state;
    let event = this.state.event;

    return (
      <div id="welcome">
        <S3Upload setEvent={this.setEvent.bind(this)} actionProgress={this.actionProgress.bind(this)} />

        <div className="welcome-contents">
          <h1>ようこそ</h1>
          <p className="welcome-desc">はじめに、お名前とプロフィール画像を設定してください。</p>

          <div className="sample-media">
            <div className="thumbnail">
              { thumbnail
                ? <img src={thumbnail} onError={(e)=>{e.target.src=thumbnail}} />
                : <span className="material-icons no-thumbnail">account_circle</span>
              }
            </div>
          </div>

          <label>
            <input type="file" accept="image/*" onChange={(e) => { if(event.file_upload) event.file_upload.bind(this)(e, 'users/') }} />
            <span><i className="material-icons">add_photo_alternate</i>画像を選択</span>
          </label>

          <h2>お名前</h2>
          <form className="welcome-form" onSubmit={this.submit.bind(this)}>
            <input className="welcome-input" type="text" placeholder="お名前を入力"
              value={name}
              onChange={e => this.setState({ name: e.target.value })} />

            { error && <p className="welcome-error">{error}</p> }

            <a className={`button welcome-submit-button ${(!name || loading) ? 'off' : ''}`}
              onClick={(!name || loading) ? undefined : this.submit.bind(this)}>
              { loading ? '登録中...' : 'はじめる' }
            </a>
            <button className="hide" type="submit" />
          </form>
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

export default Welcome;
